import { defineStore } from 'pinia';
import { SetStatusPayload, queueStatusWrite } from 'src/stores/status/statusWrites';

import { StatusEnum } from 'src/models/status/enums';

export const useStatusStore = defineStore('status', {
	actions: {
		setTheStatusStateToReady(payload: SetStatusPayload): void {
			queueStatusWrite(payload.aggregateIds, StatusEnum.READY, {
				commandBus: payload.commandBus,
				processId: payload.processId,
			});
		},
		setTheStatusStateToSeen(payload: SetStatusPayload): void {
			queueStatusWrite(payload.aggregateIds, StatusEnum.SEEN, {
				commandBus: payload.commandBus,
				processId: payload.processId,
			});
		},
		setTheStatusStateToUnseen(payload: SetStatusPayload): void {
			queueStatusWrite(payload.aggregateIds, StatusEnum.UNSEEN, {
				commandBus: payload.commandBus,
				processId: payload.processId,
			});
		},
	},
	state: () => ({}),
});
export * from './types';
